import { render } from "./button.html?vue&type=template&id=c83f01de&scoped=true&ts=true"
import script from "./button.ts?vue&type=script&lang=ts"
export * from "./button.ts?vue&type=script&lang=ts"

import "./button.scss?vue&type=style&index=0&id=c83f01de&lang=scss&scoped=true"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Vigiflow\\automation-logs-adminlte-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c83f01de"]])

export default __exports__